import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/public/assets/Franchise/hardware-image.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/public/assets/Franchise/partnership-network.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/public/assets/GetABrick/two-brick-power-banks.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/public/assets/Localized/branded-image.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/public/assets/Localized/charging-image.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/public/assets/stations/condo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/public/assets/stations/hut.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/public/assets/stations/skyscraper.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/public/assets/stations/totem.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/public/assets/stations/tower.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/public/assets/WorkPlaceBrick/people-using-power-bank-at-work.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/public/assets/world-map.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web-home/src/app/[locale]/home/GeneralVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web-home/src/app/[locale]/home/LocalizedVideo.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web-home/src/components/LinkWithQuery.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
